import { Content } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { createTitle } from "@/functions/createTitle";
import { getNestedRoutes } from "@/functions/getNestedRoutes";
import { logo_carousel_helper } from "@/helpers/logo_carousel_helper";
import sn from "@/snippets";

import * as additionalComponents from "./__components";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} logoCarousel={false} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps() {
  const page = simple_pages_helper.find("why-choose-blue-arrow", "url_slug", "b38dbdc9-ec3d-4967-b585-9e93930e2fc9");
  const pages = getNestedRoutes({
    url_slugs: ["recruitment-solutions", "why-choose-blue-arrow"],
    overwrites: { "recruitment-solutions": { href: "/recruitment-solutions/why-choose-blue-arrow/" } },
  });
  const [_page, prevPage] = [...pages].reverse();
  const logoItems = logo_carousel_helper.fetch({
    filter: (i) => i.tags.toLowerCase().includes(_page.url_slug ?? "why-choose-blue-arrow") || i.tags.includes("*"),
  });

  return {
    props: {
      meta: {
        title: createTitle(page.title),
        canonical: "https://www.bluearrow.co.uk" + getRoute("products")
      },
      content: [
        { component: "BreadcrumbNavigation", props: { items: pages } },
        sn.header({ page, prevPage }),
        ...sn.richText({ page, config: { bodyKey: "intro" }, after: { component: "Divider" } }),
        ...sn.statCounterWidget({ page, after: { component: "Divider" } }),
        ...sn.trendingJobs({ page, after: { component: "Divider" } }),
        ...sn.narrativePanels({ page, after: { component: "Divider" } }),
        ...sn.gridButtons({ page, md: 4, after: { component: "Divider" } }),
        ...sn.benefits({ page }),
        {
          component: "LogoCarousel",
          props: {
            items: logoItems,
            title: { path: "component.logoCarousel.title", placeholder: "Our Partners" },
          },
        },
        sn.chatbot({ page }),
      ],
    },
  };
}
